import { SeasonStore } from '@yarmill/types';
import { getLastSeasonEnd } from './get-last-season-end';
import { getWeekEnd } from './get-week-end';

export function getMaxBookDate(seasons: SeasonStore[]): Date {
  return getWeekEnd(getLastSeasonEnd(seasons)).toDate();
}
